<template>
  <div class="srore-wrapper">
    <suitable-store
      @StoreController="onStoreController"
      v-if="status"
      :sku-tags="skuTags"
      :isOpenReplacement="isOpenReplacement"
      :isCustomisedGoods="isCustomisedGoods"
      @onStoreSelected="onStoreChanged"
      :product="product"
    />
    <template v-else>
      <!-- <RecoveryStoreInfo :product="product" v-if="useRecovery" /> -->
      <!-- <StoreInfo :product="product" v-else /> -->
      <StoreInfo :product="product" />
    </template>
  </div>
</template>
<script>
// import RecoveryStoreInfo from '@/components/home/recovery/storeInfo'
import StoreInfo from '@/components/home/storeInfo'
import SuitableStore from '@/components/storeInfo/suitableStore'

import { E_SKUTAG } from '@/config'
import { queryDetailBySkuId } from '@/service/product'
import { isNonEmptyArray, isNullOrEmpty } from '@/utils'
import B_GOODS from '@/business/goods'

export default {
  props: ['product', 'useRecovery'],
  components: {
    SuitableStore,
    // RecoveryStoreInfo,
    StoreInfo
  },
  data() {
    const { source, saleAttribute } = this.product
    const isCustomisedGoods = B_GOODS.isSKUGoods(source, saleAttribute)
    return {
      status: true,
      skuTags: [],
      isOpenReplacement: isCustomisedGoods,
      isCustomisedGoods,
      newStoreInfo: null
    }
  },
  async created() {
    if (this.isOpenReplacement) {
      this.status = true
    } else {
      await this.setStatusWithSKUTags()
    }
  },
  methods: {
    async setStatusWithSKUTags() {
      let status = true
      let skuTags = []
      const { cmmdtySpecs = [] } = this.product
      cmmdtySpecs.forEach(x => {
        if (!isNullOrEmpty(x.skuTag)) {
          skuTags.push(x.skuTag)
        }
      })
      // 去重
      skuTags = [...new Set(skuTags)]
      // skuTag有可能出现为空或0的情况，需要单独根据SKU查询商品详情接口 来取skuTag
      if (skuTags.length === 0 || (skuTags.length === 1 && +skuTags[0] === 0)) {
        let skuId = this.$route.query.skuId
        if (isNullOrEmpty(skuId) && isNonEmptyArray(cmmdtySpecs)) {
          skuId = cmmdtySpecs[0].skuId
        }
        if (!isNullOrEmpty(skuId)) {
          const res = await queryDetailBySkuId(skuId)
          if (res.sku && res.sku.base) {
            const { skuTag } = res.sku.base
            if (!isNullOrEmpty(skuTag)) {
              skuTags.length = 0
              skuTags.push(skuTag)
            }
          }
        }
      }
      let arrStore = [
        E_SKUTAG.POPTRAIN,
        E_SKUTAG.POPSTORE,
        E_SKUTAG.POPHOME,
        E_SKUTAG.STORE_SPECIAL
      ]
      let arrBusiness = [
        E_SKUTAG.SELFSTORE,
        E_SKUTAG.SELFHOME,
        E_SKUTAG.POPYUSAO,
        E_SKUTAG.POPENTITY,
        E_SKUTAG.TRAVEL_TICKET,
        E_SKUTAG.UNIONHOME,
        E_SKUTAG.ONLINE_EDU_9
      ]
      if (arrStore.filter(x => skuTags.indexOf(x) > -1).length > 0) {
        status = true
      } else if (arrBusiness.filter(x => skuTags.indexOf(x) > -1).length > 0) {
        // skuTag in [1,2,3,5,8]
        status = false
      }
      if (!isNonEmptyArray(skuTags)) {
        status = false
      }
      this.status = status
      this.skuTags = skuTags
    },
    onStoreController(status) {
      this.status = status
    },
    onStoreChanged(storeInfo) {
      // 更换的门店信息
      this.newStoreInfo = storeInfo
      this.$emit('onStoreSelected', storeInfo)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/mixin';
.srore-wrapper {
  padding-bottom: rem(20px);
}
</style>
